import {animate, style, transition, trigger} from '@angular/animations';

export const fadeInAnimation = trigger('fadeInAnimation', [
    transition('void=>*', [
        style({ opacity: 0 }), animate('300ms', style({ opacity: 1 }))
    ])]
);
